import TempConv from "./TempConv";
export default TempConv;